import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import AppInput from '../../../../common/AppInput/index';
import DatePickers from '../../../../common/DatePickers';
import Message from '../../../../common/Message';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import {
  INFO_GO_MY_ACCOUNT_INVOICE_COPY,
  COMPLETE_FORM,
} from '../../../../../constants/texts';
import { useInvoiceCopyStyles } from './styles';
import { textMapper } from '../../../../../helpers/FormHelper';

const Form = ({ ...props }) => {
  const { state, onData, mobile, fields, motiveId } = props;
  const classes = useInvoiceCopyStyles({ mobile });

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  const handleDate = (date) => {
    onData({ name: 'purchaseDate', value: date });
  };

  return (
    <React.Fragment>
      <MotiveTitle
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        icon={textMapper.get(motiveId).icon}
        mobile={mobile}
      />

      <Message
        severity="info"
        message={INFO_GO_MY_ACCOUNT_INVOICE_COPY}
        fullRounded
      />

      <Typography className={classes.title}>{COMPLETE_FORM}</Typography>

      {fields.map((field, index) => (
        <React.Fragment key={index}>
          {field.inputType !== 'date' && (
            <AppInput
              onChange={handleChange}
              onBlur={() => {}}
              onClick={() => {}}
              disabled={state[field.name]?.disabled || false}
              name={field.name}
              error={state[field.name]?.error || false}
              type={state[field.name]?.type || ''}
              label={state[field.name]?.label || ''}
              required={state[field.name]?.required || false}
              inputAdornment={state[field.name]?.inputAdornment || ''}
              success={state[field.name]?.success || ''}
              helperText={state[field.name]?.helper || ''}
              multiline={state[field.name]?.multiline || false}
              rows={state[field.name]?.rows || ''}
              value={state[field.name]?.value || ''}
              errorMessage={state[field.name]?.message || ''}
            />
          )}
          {field.inputType === 'date' && (
            <DatePickers
              onChange={handleDate}
              name={field.name}
              label={state[field.name]?.label || ''}
              required={state[field.name]?.required || false}
              disabled={state[field.name]?.disabled || false}
              success={state[field.name]?.success || ''}
              error={state[field.name]?.error || false}
              errorMessage={state[field.name]?.message || ''}
              value={state[field.name]?.value || ''}
              disableFuture={true}
              helperText={state[field.name]?.helper || ''}
            />
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  mobile: PropTypes.bool,
  fields: PropTypes.array,
  motiveId: PropTypes.string,
};

export default Form;
